import { ServiceTypeEnum } from '@sr-sdks/api-sdk-axios';
import { AppBadge } from './AppBadge';
import { SERVICE_BADGE_PRESETS, isServiceBadgeType } from './appBadgeConstants';

interface ServiceBadgeProps {
  serviceType: ServiceTypeEnum;
  /**
   * Render `type.shortLabel` instead of the full descriptive name. Off by
   * default — matches `AppBadge`'s own default — so the full name (e.g.
   * "Royalties ANZ") is what renders unless a caller opts into the compact
   * preset label for a space-constrained table cell.
   */
  shortLabel?: boolean;
}

/**
 * Service-type pill for tables, driven by the shared `SERVICE_BADGE_PRESETS`
 * meta.
 */
export const ServiceBadge = ({ serviceType, shortLabel }: ServiceBadgeProps) =>
  isServiceBadgeType(serviceType) && (
    <AppBadge
      shortLabel={shortLabel}
      type={SERVICE_BADGE_PRESETS[serviceType]}
    />
  );
